import { SHIPPING_RATE_LOGS_ACTIONS } from './shippingRateLogs.types'

/**
 * @param {Object.<string, import('./shippingRateLogs.types').ShippingRateLog>} payload
 * @returns {Object}
 */
export const setShippingRateLogsAction = payload => ({
  type: SHIPPING_RATE_LOGS_ACTIONS.SET_LOGS,
  payload
})

/**
 * @param {import('./shippingRateLogs.types').ShippingRateLog} payload
 * @returns {Object}
 */
export const setShippingRateLogAction = payload => ({
  type: SHIPPING_RATE_LOGS_ACTIONS.SET_LOG,
  payload
})

/**
 * @param {import('../slice.types').SliceStatus} payload
 * @returns {Object}
 */
export const setShippingRateLogsStatusAction = payload => ({
  type: SHIPPING_RATE_LOGS_ACTIONS.SET_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {Object}
 */
export const setShippingRateLogsErrorsAction = payload => ({
  type: SHIPPING_RATE_LOGS_ACTIONS.SET_ERRORS,
  payload
})

/**
 * @returns {Object}
 */
export const clearShippingRateLogsErrorsAction = () => ({
  type: SHIPPING_RATE_LOGS_ACTIONS.CLEAR_ERRORS
})

/**
 * @param {Object} payload
 * @param {number} payload.pageCount
 * @param {number} payload.rowCount
 * @param {number} payload.currentPage
 * @param {number} payload.perPage
 * @returns {Object}
 */
export const setShippingRateLogsMetaAction = payload => ({
  type: SHIPPING_RATE_LOGS_ACTIONS.SET_META,
  payload
})
